/*  app.js
        - App custom JS
*/

//add event listener to megamenu link
const sectionHeader = document.getElementById('shopify-section-header');
const siteNav = document.getElementById('SiteNav');
const megaLinks = document.getElementsByClassName('custom-megamenu');
const megaMenu = document.getElementById('custom-megamenu-target');
//const megaTitle = document.getElementsByClassName('mega-title');
const hiw_mm = document.getElementById('how-it-works-megamenu_img');
const gift_mm = document.getElementById('gifting-megamenu_img');
const pageContainer = document.getElementById("PageContainer");
const announcementBar = document.querySelector('.announcement-bar');
const path = window.location.pathname;

// for (var link of megaLinks) {
// 	link.addEventListener('click', function () {
// 		link.classList.toggle('megamenu-active');
// 		megaMenu.style.display = megaMenu.style.display === 'none' ? 'block' : 'none';
// 	})
// }

//close megamenu on click outside
// pageContainer.addEventListener('click', function () {
// 	megaMenu.style.display = "none";
// });

//close megamenu on mouseout
// sectionHeader.addEventListener('mouseleave', function () {
// 	megaMenu.style.display = "none";
// });

//add "How It Works" & "Gifting" images to megamenu
// let hiwHtml = '<img src="https://cdn.shopify.com/s/files/1/0441/4482/0389/files/choose-your-delivery-options_45e55e69-daad-4489-9495-54e0644df27a.jpg?v=1598016096">';
// let giftHtml = '<img src="https://cdn.shopify.com/s/files/1/0258/5077/3555/files/DSC_7845-alt-ed.jpg?v=1610722756">';
// if (hiw_mm != null) {
//     hiw_mm.insertAdjacentHTML('afterbegin', hiwHtml);
// }
// if (gift_mm != null) {
//     gift_mm.insertAdjacentHTML('afterbegin', giftHtml);
// }


//sticky add to cart icon
// document.addEventListener('scroll', () => {
// 	const posY = window.scrollY;
// 	const headerHeight = sectionHeader.offsetHeight;
// 	const cartIcon = document.getElementsByClassName('site-header__icon site-header__cart')[0];
// 	if (posY > headerHeight) {
// 		cartIcon.classList.add('sticky');
// 	} else {
// 		cartIcon.classList.remove('sticky');
// 	}
// });

//remove CSS from Collections collection page
// if (path === "/collections/collections") {
//     //console.log('collections');
// 	const productCardTitles = document.getElementsByClassName('product-card__title');
// 	for (let el of productCardTitles) {
// 		el.style.minHeight = "initial";
// 	}
// }

//create custom translated sites
const foreignLanguages = ["fr", "de", "nl"];
const language = window.location.host.split('.')[0]; //fr / de / nl

if (foreignLanguages.includes(language)) {
	customLanguage(language);	
}

function customLanguage(lng) {

	hideLinks();
	hideContent();
	hideProducts();
	// translateContent();
	// translateProducts();
	// translatePages();

	function hideLinks() {

		//hide megamenu and stockists as well as links to shop
		const ctas = document.querySelectorAll("[href='/collections/all']"); //Hide links to shop
		ctas.forEach((el) => { el.style.display = "none" }); 
		megaLinks[0].style.display = "none"; //Hide Shop Ice Cream Megamenu
		const cart = document.querySelector(".site-header__cart"); //Hide cart
		cart.style.display = "none";

		if (lng === "fr") { //only hide stockists for French site
			siteNav.querySelectorAll('li')[2].style.display = "none"; //Stockists
		}
		//Hide uk exclusive products
		const cookieIceCream = document.querySelector("[href='/collections/ice-cream/products/cookies-cream-ice-cream-tub-475ml']");
		cookieIceCream.parentElement.parentElement.style.display = "none";
		const chocNChill = document.querySelector("[href='/collections/ice-cream/products/choc-n-chill-cbd-ice-cream-tub-475ml']");
		chocNChill.parentElement.parentElement.style.display = "none";
		
	}

	function hideContent() {
		//hide specific elements
		const elementsToHide = [
			".announcement-bar", 
			".mega-subtitle", 
			"#shopify-section-1595493056540", 
			".section-header h3", 
			".filters-toolbar-wrapper",
			"li.site-footer__linklist-item:first-child",
			"li.site-footer__linklist-item:nth-child(4)",
			"li.site-footer__linklist-item:nth-child(5)",
			"#shopify-section-product-recommendations",
			".powr-image-slider"
		];
		elementsToHide.forEach((el) => {
			const target = document.querySelectorAll(el);
			if (target.length > 0) {
				//target[0].style.display = "none";
				target.forEach((i) => {
					i.style.display = "none";
				})
			}
		});

		//hide add to cart buttons, price tags and mobile nav
		const atcButtons = document.getElementsByClassName("product-form__cart-submit-home");
		const aptcButtons = document.getElementsByClassName("product-form__cart-submit");
		const priceTags = document.getElementsByClassName("price");
		const productPriceTags = document.getElementsByClassName("product__price");
		const shopIceCream = document.querySelectorAll(".mobile-nav__item:nth-child(2)");
		const stockists = document.querySelectorAll(".mobile-nav__item:nth-child(3)");
		if (atcButtons.length > 0) {
			for (let button of atcButtons) {
				button.style.display = "none";
			}	
		}
		if (aptcButtons.length > 0) {
			for (let button of aptcButtons) {
				button.style.display = "none";
			}	
		}
		if (priceTags.length > 0) {
			//console.log(priceTags)
			for (let tag of priceTags) {
				tag.style.display = "none";
			}
		}
		if (productPriceTags.length > 0) {
			for (let tag of productPriceTags) {
				tag.style.display = "none";
			}
		} 
		if (shopIceCream.length > 0) {
			for (let item of shopIceCream) {
				item.style.display = "none";
			}
		} 
		if (stockists.length > 0) {
			for (let item of stockists) {
				item.style.display = "none";
			}
		} 

		//add custom CSS to product grid
		const collection_grid = document.querySelectorAll("#Collection ul.grid");
		if (collection_grid.length > 0) {
			collection_grid[0].style.display = "flex";
			collection_grid[0].style.flexWrap = "wrap";
		}

		//hide metafields copy
		const metafieldsCopy = document.querySelectorAll("#Collection p");
		if (metafieldsCopy.length > 0) {
			metafieldsCopy.forEach((el) => {
				el.style.display = "none";
			})
		}
	}

	function hideProducts() {
		//hide certain products on certain language sites
		const productsToHide = {
			"fr": [
				32702573772851, //Spoon
				32587325669427 //Gift card & tasting box
			],
			"de": [
				32702573772851, //Spoon
				32587325669427 //Gift card & tasting box
			],
			"nl": [
				32702573772851, //Spoon
				32587325669427 //Gift card & tasting box
			],
		}
		const countrySpecific = productsToHide[lng];
		countrySpecific.forEach((id) => {
			const el = document.querySelectorAll(`[data-id="${id}"]`);
			if (el.length > 0) {
				const parent = el[0].parentElement;
				parent.style.display = "none";
			}
		});
	}

}